// extracted by mini-css-extract-plugin
export var actualite = "detailsActu-module--actualite--9539e";
export var actualiteContentFooter = "detailsActu-module--actualite-content-footer--ae8bf";
export var actualiteContentFooterAuthor = "detailsActu-module--actualite-content-footer-author--b98d2";
export var actualiteContentFooterBack = "detailsActu-module--actualite-content-footer-back--045ce";
export var actualiteContentFooterDate = "detailsActu-module--actualite-content-footer-date--3044a";
export var actualiteContentFooterRight = "detailsActu-module--actualite-content-footer-right--2ed7b";
export var actualiteImg = "detailsActu-module--actualite-img--17403";
export var actualiteTags = "detailsActu-module--actualite-tags--73150";
export var actualiteTaxo = "detailsActu-module--actualite-taxo--22aa0";
export var actualiteTitle = "detailsActu-module--actualite-title--56405";
export var editButton = "detailsActu-module--edit-button--cd29e";
export var pageActu = "detailsActu-module--page-actu--978e8";
export var pageActuAdditionalInfos = "detailsActu-module--page-actu-additional-infos--5d6e9";
export var socialPanelContainer = "detailsActu-module--social-panel-container--feb64";